<template>
  <div>
    <Head title="Persyaratan" />
    <h1 class="mb-8 text-2xl font-bold">Persyaratan</h1>
    <div class="flex items-center justify-end w-full mb-6">
      <Link v-if="can('write persyaratan')" class="btn-indigo" href="/persyaratans/create">
        <span><font-awesome-icon icon="fas fa-plus" class="mr-2" />Tambah</span>
      </Link>
    </div>
    <div class="overflow-x-auto bg-white rounded-md shadow">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="font-bold text-left">
            <th class="px-6 pt-6 pb-4 ">Nama</th>
            <th class="px-6 pt-6 pb-4 text-center">Prestasi</th>
            <th class="px-6 pt-6 pb-4 text-center">Pra-Sejahtera</th>
            <th v-if="can('write persyaratan')" class="px-6 pt-6 pb-4 border-b">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="persyaratan in persyaratans.data" :key="persyaratan.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="p-4 overflow-hidden border-t text-ellipsis">
              {{ persyaratan.nama }}
            </td>
            <td class="p-4 text-center border-t">
              <font-awesome-icon v-if="persyaratan.mou_prestasi" icon="fas fa-circle-check" class="text-green-500" />
              <font-awesome-icon v-if="!persyaratan.mou_prestasi" icon="fas fa-circle-xmark" class="text-red-500" />
            </td>
            <td class="p-4 text-center border-t">
              <font-awesome-icon v-if="persyaratan.mou_nonprestasi" icon="fas fa-circle-check" class="text-green-500" />
              <font-awesome-icon v-if="!persyaratan.mou_nonprestasi" icon="fas fa-circle-xmark" class="text-red-500" />
            </td>
            <td v-if="can('write persyaratan')" class="w-px p-4 border-t">
              <Link class="rounded-l btn-indigo-sm" :href="`/persyaratans/${persyaratan.id}/edit`">
                <font-awesome-icon icon="fas fa-pencil" />
              </Link>
              <Link class="rounded-r btn-red-sm" @click.prevent="destroy(persyaratan.id)">
                <font-awesome-icon icon="fas fa-trash" />
              </Link>
            </td>
          </tr>
          <tr v-if="persyaratans.data.length === 0">
            <td class="px-6 py-4 border-t" :colspan="can('write persyaratan')? 5 : 4">Tidak ada data persyaratan.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="persyaratans.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'

export default {
  components: {
    Head,
    Link,
    Pagination,
  },
  layout: Layout,
  props: {
    persyaratans: Object,
  },
  methods: {
    destroy(id) {
      this.$swal.fire({
        title: 'Anda yakin hapus data ini?',
        text: 'Anda tidak akan dapat mengembalikan data yang sudah dihapus!',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(`/persyaratans/${id}`)
        }
      })
    },
  },
}
</script>
